"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class CredentialsApi extends runtime.BaseAPI {
    /**
     * Create a credential owned by a site or an user. Permissions - this method can only be called by site admin or server admin if a credential is owned by a site.
     * Create a credential owned by a site or an user.
     */
    credentialsServiceCreateCredentialRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.credentials.v1.CredentialMessage+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/credentials/creds/`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauCredentialsV1CredentialMessageToJSON(requestParameters.tableauCredentialsV1CredentialMessage),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauCredentialsV1CredentialIdFromJSON(jsonValue));
        });
    }
    /**
     * Create a credential owned by a site or an user. Permissions - this method can only be called by site admin or server admin if a credential is owned by a site.
     * Create a credential owned by a site or an user.
     */
    credentialsServiceCreateCredential(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.credentialsServiceCreateCredentialRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Delete a credential owned by a site or an user. Permissions - this method can only be called by site admin or server admin if a credential is owned by a site.
     * Delete a credential owned by a site or an user.
     */
    credentialsServiceDeleteCredentialRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.name === null || requestParameters.name === undefined) {
                throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling credentialsServiceDeleteCredential.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/credentials/creds/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete a credential owned by a site or an user. Permissions - this method can only be called by site admin or server admin if a credential is owned by a site.
     * Delete a credential owned by a site or an user.
     */
    credentialsServiceDeleteCredential(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.credentialsServiceDeleteCredentialRaw(requestParameters);
        });
    }
    /**
     * Read credential for external clients. This is the only method that returns credential data outside of Tableau Server.
     * Read credential for external clients.
     */
    credentialsServiceGetWebCredentialRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.name === null || requestParameters.name === undefined) {
                throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling credentialsServiceGetWebCredential.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/credentials/creds/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauCredentialsV1CredentialMessageFromJSON(jsonValue));
        });
    }
    /**
     * Read credential for external clients. This is the only method that returns credential data outside of Tableau Server.
     * Read credential for external clients.
     */
    credentialsServiceGetWebCredential(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.credentialsServiceGetWebCredentialRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * List credentials owned by a site or an user. Permissions - this method can only be called by site admin or server admin if a credential is owned by a site.
     * List credentials owned by a site or an user.
     */
    credentialsServiceListCredentialsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.credentials.v1.ListCredentialsRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/credentials/creds/list`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauCredentialsV1ListCredentialsRequestToJSON(requestParameters.tableauCredentialsV1ListCredentialsRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauCredentialsV1ListCredentialsResponseFromJSON(jsonValue));
        });
    }
    /**
     * List credentials owned by a site or an user. Permissions - this method can only be called by site admin or server admin if a credential is owned by a site.
     * List credentials owned by a site or an user.
     */
    credentialsServiceListCredentials(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.credentialsServiceListCredentialsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Update a credential owned by a site or an user. Permissions - this method can only be called by site admin or server admin if a credential is owned by a site.
     * Update a credential owned by a site or an user.
     */
    credentialsServiceUpdateCredentialRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.credentials.v1.CredentialMessage+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/credentials/creds/`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauCredentialsV1CredentialMessageToJSON(requestParameters.tableauCredentialsV1CredentialMessage),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Update a credential owned by a site or an user. Permissions - this method can only be called by site admin or server admin if a credential is owned by a site.
     * Update a credential owned by a site or an user.
     */
    credentialsServiceUpdateCredential(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.credentialsServiceUpdateCredentialRaw(requestParameters);
        });
    }
}
exports.CredentialsApi = CredentialsApi;
